<template>
  <div>
    <v-row>
      <v-col>
        <upload-excel
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :lastBlankRow="0"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" v-if="isCliente == 0">
            <v-combobox
                v-model="clienteG"
                :items="clientes"
                item-text="name"
                item-value="id"
                label="Cliente"
                append-icon="mdi-handshake"
                return-object
            ></v-combobox>
          </v-col>
        <v-col>
            <v-btn color="primary" small @click="crearGuias()">Crear Guias</v-btn> -
            <v-btn color="info" small @click="limpiar()">Limpiar</v-btn>
        </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
        :items="tableData"
        :headers="headers"
        class="elevation-1"
        >
        <!--template v-slot:expanded-item="{ item }">
          <span>Piezas : <strong>{{item.detpiezas != undefined ? item.detpiezas.length : 0}}</strong></span>
            <v-simple-table>
            <thead>
              <tr>
                <th>Piezas</th>
                <th>Peso</th>
                <th>Largo</th>
                <th>Ancho</th>
                <th>Alto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(resp, index) in item.detpiezas" :key="index">
                <td>{{resp.piezas}}</td>
                <td>{{resp.peso}}</td>
                <td>{{resp.largo}}</td>
                <td>{{resp.ancho}}</td>
                <td>{{resp.alto}}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-divider></v-divider>
          <span v-if="item.detitems">Items de Factura : <strong>{{item.detitems != undefined ? item.detitems.length : 0}}</strong></span>
            <v-simple-table v-if="item.detitems">
            <thead>
              <tr>
                <th>Descripcion</th>
                <th>Cantidad</th>
                <th>Costo Unitario</th>
                <th>Pais Origen</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(resi, index) in item.detitems" :key="index">
                <td>{{resi.descripcion}}</td>
                <td>{{resi.cantidad}}</td>
                <td>{{resi.costo}}</td>
                <td>{{resi.paisfab}}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-divider></v-divider>
        </template-->
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="procesado">
      <v-col>
         <v-alert dense type="info">
          Se han creado satisfactoriamente las siguientes Guías!!!
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="procesado">
      <v-col>
        <v-simple-table>
            <thead>
              <tr>
                <th>No</th>
                <th>Tipo</th>
                <th>Guía Creada</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(guia, index) in guiasCreadas" :key="index">
                <td>{{guia.No}}</td>
                <td>{{guia.tipo}}</td>
                <td>{{guia.guia_interna}}</td>
              </tr>
            </tbody>
          </v-simple-table>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <waiting :totalGuias="tableData.length" :currentGuia="currentGuia" :guiaCreada="guiaCreada" />
    </v-overlay>
    <v-dialog v-model="erroresDlg" width="800px" transition="dialog-bottom-transition" persistent>
      <v-card elevation="24" outlined>
        <v-toolbar dark color="#96298A" dense>
          <v-toolbar-title>
            Errores : <strong> {{errores.length}} </strong>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="erroresDlg = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-divider vertical />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Guia No</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(err, index) in errores" :key="index">
                <td><strong>{{err.guia}}</strong></td>
                <td>{{err.error}}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadExcel from "../components/UploadExcel.vue";
import Waiting from "../components/WaitingCreandoGuias.vue";
import apicon from '../plugins/apicon';
const Ajv = require('ajv');
const ajv = new Ajv({allErrors:true});
export default {
  created: function () {},
  components: {
    UploadExcel,
    Waiting,
  },
  data() {
    return {
      overlay: false,
      tableData: [],
      tableHeader: [],
      currentGuia: 1,
      guiaCreada: null,
      erroresDlg : false,
      errores:[],
      clientes: [],
      clienteG: null,
      headers: [
        { text: "Guia", value: "guia_interna" },
        { text: "Contacto", value: "contacto_c" },
        { text: "Empresa", value: "empresa_c" },
        { text: "Telefono", value: "telefono_c" },
        { text: "Dirección 1", value: "direccion1_c" },
        { text: "Dirección 2", value: "direccion2_c" },
        { text: "Dirección 3", value: "direccion3_c" },
        { text: "Provincia", value: "provincia_c" },
        { text: "Ciudad", value: "ciudad_c" },
        { text: "ZIP", value: "zip_c" },
        { text: "Descripción", value: "descripcion" },
        { text: "Tipo", value: "tipo" },
        { text: "Servicio", value: "servicio" },
        { text: "Piezas", value: "piezas" },
        { text: "Largo", value: "largo" },
        { text: "Ancho", value: "ancho" },
        { text: "Alto", value: "alto" },
        { text: "Peso", value: "peso" },
        { text: "Valor", value: "valor" },
        { text: "Seguro", value: "seguro" },
        { text: "Referencia 1", value: "referencia1" },
        { text: "Referencia 2", value: "referencia2" },
        { text: "Referencia 3", value: "referencia3" },
      ],
      schema : {
        type: 'object',
        properties: {
          contacto_c :{
            type: "string",
            minimun: 2,
            maxLength : 35,
          },
          empresa_c :{
            type: "string",
            minimun: 2,
            maxLength : 35,
          },
          telefono_c :{
            type: "string",
            minimun: 2,
            maxLength : 25,
          },
          direccion1_c :{
            type: "string",
            minimun: 2,
            maxLength : 35,
          },
          direccion2_c :{
            type: "string",
            minimun: 2,
            maxLength : 35,
          },
          pais_c :{
            type: "string",
            minimun: 2,
            maxLength : 35,
          },
          ciudad_c :{
            type: "string",
            minimun: 2,
            maxLength : 35,
          },
          descripcion :{
            type: "string",
            minimun: 2,
            maxLength : 45,
          },
          tipo :{
            type: "string",
            minimun: 1,
          },
          servicio :{
            type: "string",
            minimun: 1,
          },
        },
        required: [
          "contacto_c",
          "empresa_c",
          "telefono_c",
          "direccion1_c",
          "direccion2_c",
          "ciudad_c",
          "descripcion",
          "tipo",
          "servicio",
          ]
      },
      replaceable: {
          contacto_c : "Contacto",
          empresa_c : "Empresa",
          telefono_c : "Telefono",
          direccion1_c : "Dirección 1",
          direccion2_c : "Dirección 2",
          ciudad_c : "Ciudad",
          descripcion : "Descripción",
          tipo : "Tipo",
          servicio : "Servicio",
      },
      guiasCreadas : [],
      procesado: false,
      cliente: null,
      sheetName: null,
      isCliente: 1
    };
  },
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$swal("No se pueden subir archivos mayortes a 1MB");
      return false;
    },
    handleSuccess({ results, header, sheetName }) {
      this.tableData = results;
      this.tableHeader = header;
      this.sheetName = sheetName;
      this.procesado = false;
      this.guiasCreadas = [];
      this.currentGuia = 1;
    },
    limpiar: function(){
      this.tableData = [];
      this.tableHeader = [];
      this.guiasCreadas = [];
      this.procesado = false;
      this.currentGuia = 1;
      this.clienteG = null;
    },
    crearGuias:async  function () {
      if(this.clienteG == null){
        this.$swal('Por favor seleccione el cliente al que le asignara las guias creadas');
        return;
      }
      //Verificar si hay guias
      if(this.tableData.length == 0){
        this.$swal("No ha importado datos");
        return;
      }
      //verificar que se haya importado un archivo valido
      if(this.sheetName != 'nacional' && this.sheetName != 'exportacion' && this.sheetName != 'importacion'){
        this.$swal("El tipo de archivo importado parece no ser valido 'nacional|exportacion|importacion' - SheetName: " + this.sheetName);
        return;
      }
      //Validar los datos de la guia
      let datosValidos = await this.validarDatosGuias();
          if(!datosValidos){
            this.$swal("Se encontraron errores de validacion, por favor corrija y vuelva a importar el archivo");
            this.erroresDlg = true;
            return;
          }
      this.overlay = true;
      for (var i = 0; i <= this.tableData.length - 1; i++) {
        //Agregar los datos del embarcador del usuario
        this.tableData[i].contacto_e = this.clienteG.contacto
        this.tableData[i].empresa_e = this.clienteG.empresa
        this.tableData[i].telefono_e = this.clienteG.telefono
        this.tableData[i].direccion1_e = this.clienteG.direccion1
        this.tableData[i].direccion2_e = this.clienteG.direccion2
        this.tableData[i].direccion3_e = this.clienteG.direccion3
        this.tableData[i].correo_e = this.clienteG.correo
        this.tableData[i].pais_e = this.clienteG.pais
        this.tableData[i].ciudad_e = this.clienteG.ciudad
        this.tableData[i].provincia_e = this.clienteG.provincia
        this.tableData[i].zip_e = this.clienteG.zip
        //agregar el tipo de guia
        this.tableData[i].tipoguia = this.sheetName
        //setear el tipo
        let tipo = this.tableData[i].tipo;
        switch (tipo){
          case "1":
            this.tableData[i].tipo = "Documentos"
            break;
          case "2":
            this.tableData[i].tipo = "No Documento"
            break;
        }
        //Setear el servicio
        let servicio = this.tableData[i].servicio
        switch(servicio){
          case "1":
            this.tableData[i].servicio = "Valija Nacional"
            break;
          case "2":
            this.tableData[i].servicio = "Valija Local"
            break;
          case "3":
            this.tableData[i].servicio = "Valija Interna"
            break;
        }
        //crear las piezas (solo una pieza)
        let pzas = [
          {
            piezas : this.tableData[i].piezas,
            peso : (parseFloat(this.tableData[i].peso) / parseFloat(this.tableData[i].piezas)),
            largo : this.tableData[i].largo != null ? this.tableData[i].largo : 0,
            ancho : this.tableData[i].ancho != null ? this.tableData[i].ancho : 0,
            alto : this.tableData[i].alto != null ? this.tableData[i].alto : 0,
            pesototal : this.tableData[i].peso,
            volumentotal : 0,
            unidad_peso : 'kgs',
            unidad_medida : 'cms',
          }
        ]
        this.tableData[i]['detpiezas'] =  JSON.stringify(pzas)
        this.tableData[i]['detitems'] =  JSON.stringify([])
        this.tableData[i]['pais_c'] = 'EC' //Nacionales
          /*if(!this.tableData[i].detpiezas){
            this.tableData[i].detpiezas = await JSON.stringify([]);
          }else{
            await this.calcularPesoTotalPaquete(this.tableData[i].detpiezas);
            await this.setTotalesGuia(this.tableData[i]);
            this.tableData[i].detpiezas = await JSON.stringify(this.tableData[i].detpiezas);
          }
          if(!this.tableData[i].detitems){
            this.tableData[i].detitems = await JSON.stringify([]);
          }else{
            await this.calcularTotalesItem(this.tableData[i].detitems);
            this.tableData[i].detitems = await JSON.stringify(this.tableData[i].detitems);
          }*/
          this.tableData[i]['id_usuario'] = this.cliente != null ? this.clienteG.id : null;
          this.tableData[i]['cuenta'] = this.cliente != null ? this.clienteG.codigo : null;
          await apicon.saveDataApi(apicon.getApiBaseUrl() + 'guias',this.tableData[i]).then((result) =>{
              if(result.status){
                this.guiaCreada = result.data.guia_interna;
                this.guiasCreadas.push({
                  No: this.tableData[i].No,
                  tipo: this.tableData[i].tipoguia,
                  guia_interna: result.data.guia_interna
                });
                this.currentGuia ++;
              }else{
                console.log(result.data);
              }
          });
      }
      this.overlay = false
      this.tableData = [];
      this.procesado = true;
      this.currentGuia = 1;
    },
    validarDatosGuias:async function(){
      let flag = true;
      this.errores = [];
      for (var i = 0; i <= this.tableData.length - 1; i++) {
        //Verificar si tiene paquetes
        /*if(!this.tableData[i].detpiezas){
          await this.errores.push({guia: this.tableData[i].No, error: 'No tiene piezas'});
          flag = false;
        }*/
        //Verificar campos obligatorios
        let flgValidacion = await this.validarCamposObligatorios(this.tableData[i]);
        if(!flgValidacion){
          flag = false;
        }
        //Reemplazar las variable para mejor presentacion al usuario.
        this.replaceVar();
      }
      return flag;
    },
    validarCamposObligatorios:async function(guia){
      let flag = true;
      var valid = await ajv.validate(this.schema,guia);
      if(!valid){
        flag = false;
        //For recorriendo los errores
        console.log(ajv.errors);
        for(let i = 0; i< ajv.errors.length; i++){
          this.errores.push({guia: guia.No, error: ajv.errors[i].dataPath + ' ' + ajv.errors[i].message})
        }
      }
      return flag;
    },
    replaceVar: function(){
      let lookup = this.replaceable || {};
      Object.keys(lookup).forEach((key) => {
        for(var i=0; i < this.errores.length; i++){
         this.errores[i].error = this.errores[i].error.replace(new RegExp("\\b" + key + "\\b", "g"),lookup[key]);
        }
      });
    },
    setTotalesGuia:async function(guia){
      //calcular el peso total
      let pesoT =  guia.detpiezas.reduce((sump,item) => sump + parseFloat(item.pesototal),0);
      let volumenT =  guia.detpiezas.reduce((sumv,item) => sumv + parseFloat(item.volumentotal),0);
      let piezasT = guia.detpiezas.reduce((sumpi,item) => sumpi + parseFloat(item.piezas),0);

      guia.peso = pesoT;
      guia.peso_cobrar = pesoT;
      guia.volumen = volumenT;
      guia.piezas = piezasT;
    },
    calcularPesoTotalPaquete:async function(item){
      for(let i=0; i< item.length; i++){
        item[i].pesototal = await item[i].piezas * item[i].peso;
        var dim = await item[i].largo * item[i].ancho *item[i].alto;
        item[i].volumentotal = Math.round((dim / 5000) * item[i].piezas * 100) / 100;
        item[i].unidad_peso = 'kgs';
        item[i].unidad_medida = 'cm';
      }
    },
    calcularTotalesItem: async function(item){
      for(let i=0; i< item.length; i++){
        item[i].unidad = null;
        item[i].arancel = null;
        item[i].peso_neto = null;
        item[i].peso_bruto = null;
        item[i].total = await item[i].costo * item[i].cantidad;
      }
    },
    getDatosCliente:async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'usuario/' + localStorage.getItem("userid"))
            .then(async (result) => {
              this.cliente = result;
            });
    },
    fillClientes:async function () {
      await apicon.getDataApi(apicon.getApiBaseUrl() + "usuario").then((result) => {
        this.clientes = result;
      });
    },
  },
  mounted:async function () {
      await apicon.setAuthHeaders();
      await this.getDatosCliente();
      await this.fillClientes();
      this.isCliente = localStorage.getItem('cliente')
  },
};
</script>

<style>
</style>
